import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/BusTicketPrices/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/BusTicketPrices/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/BusTicketPrices/GetById`, payload),
    Add: (payload) => Repository.post(`/api/BusTicketPrices/Add`, payload),
    Edit: (payload) => Repository.post(`/api/BusTicketPrices/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/BusTicketPrices/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/BusTicketPrices/ChangeStatus`, payload),
}